export default __webpack_public_path__ + "static/media/leave-right.67acddbd.png";